import React from 'react';
import { Router, Route, browserHistory } from 'react-router';
import { App } from 'App';
import { Main } from './views/main/Main';

export const routes = (
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <Route path="ct/panel/:panel(/lc/:lc)(/preview/:preview)" component={Main} />
    </Route>
  </Router>
);



// WEBPACK FOOTER //
// ./routes.js